(function () {
  'use strict';

  function initGallery(root) {
    var slides = Array.from(root.querySelectorAll('[data-mfx-media-slide]'));
    var thumbs = Array.from(root.querySelectorAll('[data-mfx-media-thumb]'));
    var previous = root.querySelector('[data-mfx-gallery-prev]');
    var next = root.querySelector('[data-mfx-gallery-next]');
    var stage = root.querySelector('[data-mfx-gallery-stage]');
    var lightbox = root.querySelector('[data-mfx-lightbox]');
    var lightboxContent = root.querySelector('[data-mfx-lightbox-content]');
    var lightboxClose = root.querySelector('[data-mfx-lightbox-close]');
    var activeIndex = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains('is-active'); }));
    var touchStartX = 0;

    if (!slides.length) return;

    function setActive(index) {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      thumbs.forEach(function (thumb, thumbIndex) {
        var active = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function openLightbox() {
      if (!lightbox || !lightboxContent) return;
      var activeSlide = slides[activeIndex];
      var mediaButton = activeSlide.querySelector('[data-mfx-media-open]');
      var source = mediaButton || activeSlide;
      lightboxContent.replaceChildren(source.cloneNode(true));
      if (typeof lightbox.showModal === 'function') lightbox.showModal();
      else lightbox.setAttribute('open', '');
    }

    function closeLightbox() {
      if (!lightbox) return;
      if (typeof lightbox.close === 'function') lightbox.close();
      else lightbox.removeAttribute('open');
      if (lightboxContent) lightboxContent.replaceChildren();
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { setActive(index); });
    });
    root.querySelectorAll('[data-mfx-media-open]').forEach(function (button) {
      button.addEventListener('click', openLightbox);
    });
    if (previous) previous.addEventListener('click', function () { setActive(activeIndex - 1); });
    if (next) next.addEventListener('click', function () { setActive(activeIndex + 1); });
    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    if (lightbox) lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function (event) {
      if (lightbox && lightbox.open) {
        if (event.key === 'Escape') closeLightbox();
        return;
      }
      if (event.key === 'ArrowLeft') setActive(activeIndex - 1);
      if (event.key === 'ArrowRight') setActive(activeIndex + 1);
    });
    if (stage) {
      stage.addEventListener('touchstart', function (event) {
        touchStartX = event.changedTouches[0].screenX;
      }, { passive: true });
      stage.addEventListener('touchend', function (event) {
        var distance = event.changedTouches[0].screenX - touchStartX;
        if (Math.abs(distance) < 40) return;
        setActive(distance > 0 ? activeIndex - 1 : activeIndex + 1);
      }, { passive: true });
    }
  }

  function initOptions(root) {
    var buttons = Array.from(root.querySelectorAll('[data-mfx-option]'));
    var summary = root.querySelector('[data-mfx-option-summary]');
    var inquiryLinks = Array.from(root.querySelectorAll('[data-mfx-product-inquiry]'));
    if (!buttons.length) return;

    function getSelected() {
      return buttons.filter(function (button) {
        return button.getAttribute('aria-pressed') === 'true';
      }).map(function (button) {
        return button.dataset.optionName;
      });
    }

    function update() {
      var selected = getSelected();
      var selectedValue = selected.join(', ');
      if (summary) summary.textContent = selectedValue || summary.dataset.emptyLabel || 'No options selected';
      inquiryLinks.forEach(function (link) {
        link.dataset.mfxSelectedOptions = selectedValue;
        var url = new URL(link.href, window.location.origin);
        if (selectedValue) url.searchParams.set('selected_options', selectedValue);
        else url.searchParams.delete('selected_options');
        link.href = url.pathname + url.search + url.hash;
      });
      root.dispatchEvent(new CustomEvent('mfx:options-updated', {
        detail: { selected: selected, selectedValue: selectedValue }
      }));
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var active = button.getAttribute('aria-pressed') === 'true';
        button.setAttribute('aria-pressed', active ? 'false' : 'true');
        update();
      });
    });
    update();
  }

  function initInquiryModal(root) {
    var trigger = root.querySelector('[data-mfx-options-inquiry]');
    var modal = root.querySelector('[data-mfx-inquiry-modal]');
    var closeButton = modal ? modal.querySelector('[data-mfx-inquiry-close]') : null;
    var form = modal ? modal.querySelector('form') : null;
    var optionDisplay = modal ? modal.querySelector('[data-mfx-inquiry-options]') : null;
    var selectedInput = modal ? modal.querySelector('[data-mfx-selected-options-input]') : null;
    var buttons = Array.from(root.querySelectorAll('[data-mfx-option]'));
    var previousOverflow = '';

    if (!trigger || !modal || !form) return;

    function getSelectedValue() {
      return buttons.filter(function (button) {
        return button.getAttribute('aria-pressed') === 'true';
      }).map(function (button) {
        return button.dataset.optionName;
      }).join(', ');
    }

    function updateContext(value) {
      var selectedValue = typeof value === 'string' ? value : getSelectedValue();
      if (optionDisplay) optionDisplay.textContent = selectedValue || 'No factory options selected';
      if (selectedInput) selectedInput.value = selectedValue;
    }

    function openModal() {
      updateContext();
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      if (typeof modal.showModal === 'function') {
        if (!modal.open) modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      window.setTimeout(function () {
        var firstInput = form.querySelector('input:not([type="hidden"]), textarea');
        if (firstInput) firstInput.focus();
      }, 0);
    }

    function restorePage() {
      document.body.style.overflow = previousOverflow;
    }

    function closeModal() {
      if (typeof modal.close === 'function' && modal.open) modal.close();
      else modal.removeAttribute('open');
      restorePage();
      trigger.focus();
    }

    trigger.addEventListener('click', openModal);
    if (closeButton) closeButton.addEventListener('click', closeModal);
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
    modal.addEventListener('close', restorePage);
    form.addEventListener('submit', function () {
      updateContext();
    });
    root.addEventListener('mfx:options-updated', function (event) {
      updateContext(event.detail ? event.detail.selectedValue : '');
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.open) closeModal();
    });

    updateContext();
    if (form.querySelector('[data-mfx-form-feedback]')) openModal();
  }

  function init() {
    document.querySelectorAll('[data-mfx-product-detail]').forEach(function (root) {
      initGallery(root);
      initOptions(root);
      initInquiryModal(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
